module.exports = __webpack_public_path__ + "img/0010.926d380a.gif";